import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "conference_card_icon_change_bg",
  "use": "conference_card_icon_change_bg-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"conference_card_icon_change_bg\"><g fill=\"#fff\"><path d=\"m10 3 1.89 5.11L17 10l-5.11 1.89L10 17l-1.89-5.11L3 10l5.11-1.89L10 3ZM17 6l.81-2.19L20 3l-2.19-.81L17 0l-.81 2.19L14 3l2.19.81L17 6Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol